import React from 'react';
import './index.css';
import util from "../../util/tools";
import cityData from "../../util/city";
import Toast from '../common/Toast'
import LoadMore from '../common/LoadMore'

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toastText:'',
            allShow: false,//信息是否完整，默认不完整（没数据）
            multiArray: [cityData, [], []],
            data: {}
        };

        this.getInfoFun = this.getInfoFun.bind(this);
        this.xxdzFun = this.xxdzFun.bind(this);
        this.changeFun = this.changeFun.bind(this);
        this.saveFun = this.saveFun.bind(this);
        this.enterFun = this.enterFun.bind(this);
    }

    componentDidMount() {
        document.title = '物流信息'
        this.getInfoFun();
    }

    enterFun(){
        util.ajax({
            url: "/zh/drawprize/confirmReceipt",
            isUser: true,
            isWechatId: true,
            data: {
                draw_record_id: this.props.match.params.draw_record_id
            },
            callback: res => {
                this.setState({
                    toastText: res.result.status.msg
                },()=>{
                    setTimeout(()=>{
                        this.setState({
                            toastText: ""
                        },()=>{
                            if (res.result.status.code == 0) {
                                try{
                                    window.history.back();
                                }catch(e){}
                            }
                        })
                    },2000);
                })
            }
        });
    }

    getInfoFun(){
        util.ajax({
            url: "/zh/drawprize/viewAddress",
            isUser: true,
            isWechatId: true,
            data: {
                draw_record_id: this.props.match.params.draw_record_id
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let tempData = this.state.multiArray;
                    if(!!res.result.data.province){
                        tempData[1] = tempData[0].filter(function(item){
                            return item.name == res.result.data.province;
                        })[0].city;
                    }
                    if(!!res.result.data.city){
                        tempData[2] = tempData[1].filter(function(item){
                            return item.name == res.result.data.city;
                        })[0].districtAndCounty;
                    }
                    let allShow = false,valiData = {name:"",tel:"",province:"",city:"",county:"",address:""};
                    if(!!res.result.data){
                        for(var item in res.result.data){
                            if(typeof valiData[item] != "undefined"){
                                // 数据没有值
                                if(!res.result.data[item]){allShow = true;}
                            }
                        }
                        allShow = !allShow;
                    }
                    this.setState({
                        allShow: allShow,
                        data: res.result.data || {}
                    })
                }
            }
        });
    }

    xxdzFun(e) {
      const curT = e.target;
      const name = curT.getAttribute("name");
      const userInfo = this.state.data;
      userInfo[name] = curT.value;
      this.setState({
        data: userInfo
      });
    }

    changeFun(e) {
        const curT = e.target,
            name = curT.getAttribute("name"),
            curIndex = curT.getAttribute("data-index");
        const userInfo = this.state.data;
        let multiArray = this.state.multiArray;
        userInfo[name] = curT.value;
        if (curIndex == 1) {
            // 省
            userInfo["city"] = "";
            userInfo["county"] = "";

            // multiArray[0] = cityData;
            multiArray[1] = multiArray[0].filter(function(item){
                return item.name == userInfo[name];
            })[0].city;
            multiArray[2] = [];
        } else if (curIndex == 2) {
            // 市
            userInfo["county"] = "";
            multiArray[2] = multiArray[1].filter(function(item){
                return item.name == userInfo[name];
            })[0].districtAndCounty;
        }
        this.setState({
            multiArray: multiArray,
            userInfo: userInfo
        });
    }

    saveFun(){
        util.ajax({
            url: "/zh/drawprize/addAddress",
            isUser: true,
            isWechatId: true,
            data: {
                ...this.state.data,
                draw_record_id: this.props.match.params.draw_record_id
            },
            method: "POST",
            callback: res => {
                this.setState({
                    toastText: res.result.status.msg
                },()=>{
                    setTimeout(()=>{
                        this.setState({
                            toastText: ""
                        },()=>{
                            if (res.result.status.code == 0) {
                                try{
                                    window.history.back();
                                }catch(e){}
                            }
                        })
                    },2000);
                })
            }
        });
    }

    render() {
        let data = this.state.data;
        return (
            <div className='cjinfopage'>
                <div className={`list ${!!this.state.allShow?"noEdit":""}`}>
                    <div className='item' data-title="物流信息">{data.express_name}</div>
                    <div className='item' data-title="快递单号">{data.express_number}</div>
                    <div className='item mt20' data-title="收货人">
                        <input
                            type="text"
                            onInput={this.xxdzFun}
                            className="txt1"
                            name="name"
                            value={data.name}
                        />
                    </div>
                    <div className='item' data-title="手机号码">
                        <input
                            type="text"
                            onChange={this.xxdzFun}
                            className="txt1"
                            name="tel"
                            value={data.tel}
                        />
                    </div>
                    <div className='item clearfix' data-title="所在地区">
                        {
                            !!this.state.allShow ? `${data.province}${data.city}${data.county}`:
                            <div>
                                <select
                                    className="sel1"
                                    data-index="1"
                                    name="province"
                                    onChange={this.changeFun}
                                    value={data.province}
                                >
                                    {!data.province && <option>请选择省份</option>}
                                    {
                                        this.state.multiArray[0].length > 0 &&
                                        this.state.multiArray[0].map((item, index) => (
                                            <option
                                                key={`a${index}`}
                                                value={`${item.name}`}
                                            >{item.name}</option>
                                        ))
                                    }
                                </select>
                                <select
                                    className="sel1"
                                    data-index="2"
                                    name="city"
                                    onChange={this.changeFun}
                                    value={data.city}
                                >
                                    {!data.city_info && <option>请选择城市</option>}
                                    {this.state.multiArray[1].length > 0 &&
                                    this.state.multiArray[1].map((item, index) => (
                                        <option
                                            key={`b${index}`}
                                            value={`${item.name}`}
                                        >{item.name}</option>
                                    ))}
                                </select>
                                <select
                                    className="sel1"
                                    data-index="3"
                                    name="county"
                                    onChange={this.changeFun}
                                    value={data.county}
                                >
                                    {!data.county && (
                                    <option>请选择地区</option>
                                    )}
                                    {this.state.multiArray[2].length > 0 &&
                                    this.state.multiArray[2].map((item, index) => (
                                        <option
                                            key={`c${index}`}
                                            value={`${item}`}
                                        >{item}</option>
                                    ))}
                                </select>
                            </div>
                        }
                    </div>
                    <div className='item' data-title="详细地址">
                        {
                            !!this.state.allShow ? `${data.address}`:
                            <textarea
                                type="text"
                                onChange={this.xxdzFun}
                                className="txt2"
                                name="address"
                                value={data.address}
                            ></textarea>
                        }
                    </div>
                </div>
                {!this.state.allShow && <div className='saveBtn' onClick={this.saveFun}>保存</div>}
                {!!this.state.allShow && data.is_receive == 0 && <div className='saveBtn' onClick={this.enterFun}>确认收货</div>}
                <Toast text={this.state.toastText}/>
            </div>
        );
    }
}